import { Container, Grid } from "@mui/material";
import { useState } from "react";
import SwapRebalanceInfo from "../../RebalanceDetailedInfo/SwapRebalanceInfo";
import { useSelector } from "react-redux";
import { selectSwapRebalanceStrategies } from "../../../../../../Redux/Reducers/selectors";
const SwapStep2 = ({ setCurrentStep, contracts, setExecutionStyles }) => {
  const [existingNewArray, setExistingNewArray] = useState([]);
  const swapRebalanceStrategies = useSelector(selectSwapRebalanceStrategies);
  return (
    <Container disableGutters maxWidth="100%" sx={{ marginTop: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "100%",
              }}
            >
              <SwapRebalanceInfo
                setExistingNewArray={setExistingNewArray}
                existingNewArray={existingNewArray}
                contracts={swapRebalanceStrategies}
                setCurrentStep={setCurrentStep}
                setExecutionStyles={setExecutionStyles}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SwapStep2;
